"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnchorWallet = useAnchorWallet;
var react_1 = require("react");
var useWallet_1 = require("./useWallet");
/**
 * Hook for accessing a wallet that is compatible with Anchor programs
 *
 * Returns an Anchor-compatible wallet interface that supports both web3.js
 * and Kit transaction architectures.
 *
 * @returns AnchorWallet or undefined if wallet is not connected
 */
function useAnchorWallet() {
    var _a = (0, useWallet_1.useWallet)(), publicKey = _a.publicKey, signTransaction = _a.signTransaction, signAllTransactions = _a.signAllTransactions;
    return (0, react_1.useMemo)(function () {
        if (publicKey) {
            return { publicKey: publicKey, signTransaction: signTransaction, signAllTransactions: signAllTransactions };
        }
        return undefined;
    }, [publicKey, signTransaction, signAllTransactions]);
}
